var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/image"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.36 22.75H5.59a4.365 4.365 0 01-3.9-6.32l1.72-3.45a3.243 3.243 0 012.47-1.93 3.237 3.237 0 012.82 1.36l.22.28a1.736 1.736 0 001.45.78 1.735 1.735 0 001.3-1.01l1.89-3.41c.78-1.41 1.82-2.14 2.95-2.09s2.08.9 2.72 2.38l3.13 7.31a4.35 4.35 0 01-.37 4.12 4.284 4.284 0 01-3.63 1.98zm-12.2-10.2a.487.487 0 00-.12.01 1.777 1.777 0 00-1.29 1.1l-1.724 3.45a2.862 2.862 0 002.56 4.15h12.76a2.863 2.863 0 002.63-3.99L17.85 9.958c-.38-.9-.91-1.45-1.42-1.47-.47-.03-1.08.47-1.56 1.32l-1.89 3.41a3.254 3.254 0 01-2.48 1.78 3.235 3.235 0 01-2.75-1.34l-.22-.28a1.8 1.8 0 00-1.37-.828z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M6.97 8.75A3.75 3.75 0 1110.72 5a3.758 3.758 0 01-3.75 3.75zm0-6A2.25 2.25 0 109.22 5a2.253 2.253 0 00-2.25-2.25z"
  }))));
}
export default SvgVuesaxOutlineImage;